import { render, staticRenderFns } from "./alarmSendConfig.vue?vue&type=template&id=de811d9a&"
import script from "./alarmSendConfig.vue?vue&type=script&lang=js&"
export * from "./alarmSendConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports